var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-img default-thumbnail",style:({ 'background-color': _vm.placeholderColor }),attrs:{"data-qa":"default thumbnail"}},[_c('span',{class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }